import { render } from "./UpdateCustomAction.vue?vue&type=template&id=f957c4c2&scoped=true"
import script from "./UpdateCustomAction.vue?vue&type=script&lang=js"
export * from "./UpdateCustomAction.vue?vue&type=script&lang=js"

import "./UpdateCustomAction.vue?vue&type=style&index=0&id=f957c4c2&scoped=true&lang=less"

import exportComponent from "/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f957c4c2"]])

export default __exports__